import type BaseDto from '../interface/IBaseDto';
import type {
    CustomBaseDataType,
    ExternalBaseDataType,
    InternalBaseDataType,
} from '../interface/IBaseDto';
import create from './create';
import type IMapProperty from './IMapProperty';
import isEntity from './isEntity';

/** Take an incoming IMapProperty[] and generate a new object with the sourceObject  */
function apply<
    PK extends keyof IntProps,
    ExtProps extends ExternalBaseDataType,
    IntProps extends InternalBaseDataType,
    CustomProps extends CustomBaseDataType,
>(
    primaryKey: PK,
    mappings: IMapProperty[],
    customProps: CustomProps,
    sourceObject: ExtProps | BaseDto<PK, ExtProps, IntProps>,
): BaseDto<PK, ExtProps, IntProps> & IntProps & CustomProps {
    const newEntity = create<ExtProps, IntProps, CustomProps, PK>(
        primaryKey,
        mappings,
        customProps,
        /* If we are given an existing entity, flatten it out & apply that */
        isEntity(sourceObject)
            ? (sourceObject.flatten() as Partial<ExtProps>)
            : (sourceObject as Partial<ExtProps>) ?? {},
    );

    return newEntity;
}

export default apply;
